import braze from '@braze/web-sdk';

/** Marked as possibly-undefined because this export will be missing on the server
 * due to the "client-only" extension.
 *
 * This is marked client-only because merely *importing* the braze package on the server
 * causes runtime errors, since it assumes it is in a browser.
 */
export const installBraze: undefined | (() => typeof braze) = () => braze;
